// src/components/BottomNav.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CalendarDays, PlusCircle, Clock, Settings } from 'lucide-react';

const TABS = [
  { path: '/',              icon: CalendarDays, label: 'Agenda' },
  { path: '/novo',          icon: PlusCircle,   label: 'Nova' },
  { path: '/disponivel',    icon: Clock,        label: 'Horários' },
  { path: '/configuracoes', icon: Settings,     label: 'Config' },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const active = TABS.findIndex(t =>
    t.path === '/' ? location.pathname === '/' : location.pathname.startsWith(t.path)
  );

  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 100,
      background: 'var(--white)',
      borderTop: '1px solid var(--blush)',
      display: 'flex',
      paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      boxShadow: '0 -4px 20px rgba(44,35,37,0.08)',
    }}>
      {TABS.map((tab, i) => {
        const isActive = i === active;
        const Icon = tab.icon;
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '3px',
              padding: '10px 4px 10px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              position: 'relative',
              transition: 'opacity 0.15s',
            }}
          >
            {/* active indicator */}
            {isActive && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: 32,
                height: 2,
                borderRadius: '0 0 2px 2px',
                background: 'var(--rose)',
              }} />
            )}
            <Icon
              size={22}
              strokeWidth={isActive ? 2 : 1.5}
              color={isActive ? 'var(--rose)' : 'var(--slate-lt)'}
            />
            <span style={{
              fontSize: '0.65rem',
              fontWeight: isActive ? 700 : 400,
              color: isActive ? 'var(--rose)' : 'var(--slate-lt)',
              letterSpacing: '0.03em',
            }}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
